import React from 'react';
import { withRouter } from 'react-router-dom';
import { Plus, Printer, Upload } from 'react-feather';
import queryString from 'query-string';
import fileDownload from 'js-file-download';

import MainHeader from '../../components/main-header/main-header.component';
import Mainmenu from '../../components/menu/main-menu/main-menu.component';
import EmployeeCard from '../../components/card/employee-card/employee-card.component';
import AddEmployeeModal from '../../components/modal/add-employee/add-employee.component';
import PrintOutModal from '../../components/modal/print-outs/employees/employees-print-out.component';
import QuickActionCard from '../../components/card/quick-action-card/quick-action-card.component';
import ImportDataModal from '../../components/modal/import-data/import-data.component';
import ConfirmDeleteModal from '../../components/modal/confirm-delete/confirm-delete.component';

import Footer from '../../components/footer/footer.component';

import {
  Search,
  Select,
  SelectItem,
  Loading,
  Toggle,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
} from 'carbon-components-react';

//import svg icon
import { ReactComponent as Briefcase } from '../../assets/images/card-icons/briefcase.svg';
import { ReactComponent as BriefcaseRed } from '../../assets/images/card-icons/briefcase-red.svg';

import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../redux/selectors/user.selectors';

import { connect } from 'react-redux';

import { getDepartments } from '../../api/school.service';
import {
  getEmployees,
  deleteEmployee,
  importEmployees,
  exportEmployees,
} from '../../api/employee.service';

import './employee.styles.scss';
import {
  selectAllEmployees,
  selectActiveEmployees,
  selectTerminatedEmployees,
  selectDepartments,
} from '../../redux/selectors/employee.selectors';
import {
  setEmployees,
  removeEmployee,
  setDepartments,
} from '../../redux/actions/employee.actions';
import MainLoaderModal from '../../components/modal/main-loader/main-loader.component';
import { RenderIf } from '@/components/RenderIf';

const getEmployeePageStateFromSearch = (search = '') => {
  const params = queryString.parse(search);

  return {
    query: params.query || '',
    filter: params.filter || '',
    departmentId: params.departmentId || '',
    employeesToView: params.v === 'Terminated' ? params.v : 'Active',
    sortKey: params.sortKey || 'firstName',
    displayAsTable: params.t === 'table',
  };
};

const getEmployeePageSearch = (state) =>
  queryString.stringify(
    {
      query: state.query,
      filter: state.filter,
      departmentId: state.departmentId,
      v: state.employeesToView === 'Terminated' ? 'Terminated' : undefined,
      sortKey: state.sortKey,
      t: state.displayAsTable ? 'table' : undefined,
    },
    { skipEmptyString: true, skipNull: true },
  );

class EmployeePage extends React.Component {
  constructor(props) {
    super(props);

    const urlState = getEmployeePageStateFromSearch(
      props.history.location.search,
    );

    // set state
    this.state = {
      query: urlState.query,
      filter: urlState.filter,
      departmentId: urlState.departmentId,
      sortKey: urlState.sortKey,
      displayAsTable: urlState.displayAsTable,
      departments: this.props.departments,
      allEmployees: this.props.allEmployees,
      activeEmployees: this.props.activeEmployees,
      terminatedEmployees: this.props.terminatedEmployees,
      loading: false,
      errorMessage: null,
      employeesToView: urlState.employeesToView,
      openAddNewModal: false,
      openTerminateModal: false,
      openEmployeesListModal: false,
      openImportModal: false,
      selectedEmployee: null,
      openConfirmDeleteModal: false,
      deleteDescription:
        'Please confirm Employee deletion. This action cannot be reversed.',
      deleteAction: () => {},
      deleteSucessAction: () => {},
      openPrintOutModal: false,
      openImportDataModal: false,
      openLoaderModal: false,
      loaderModalDescription: 'Importing Employees...',
      loaderModalErrorMessage: null,
      loaderModaltryAgainAction: () => {},
    };
  }

  componentDidMount() {
    this.fetchEmployees();

    getDepartments(this.props.currentUser.authToken).then((response) => {
      if (response.success) {
        this.props.setDepartments(response.departments);
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const urlState = getEmployeePageStateFromSearch(
        this.props.location.search,
      );

      if (
        this.state.query !== urlState.query ||
        this.state.filter !== urlState.filter ||
        this.state.departmentId !== urlState.departmentId ||
        this.state.employeesToView !== urlState.employeesToView ||
        this.state.sortKey !== urlState.sortKey ||
        this.state.displayAsTable !== urlState.displayAsTable
      ) {
        this.setState({
          ...urlState,
        });
      }
    }

    if (this.props.departments.length !== prevProps.departments.length) {
      this.setState({ departments: this.props.departments });
    }

    if (this.props.allEmployees.length !== prevProps.allEmployees.length) {
      this.setState({ allEmployees: this.props.allEmployees });
      this.setState({ activeEmployees: this.props.activeEmployees });
      this.setState({ terminatedEmployees: this.props.terminatedEmployees });
    } else {
      // compare values
      this.props.allEmployees.forEach((newEmployee) => {
        // find old
        const oldEmployee = prevProps.allEmployees.find(
          (item) => item.id === newEmployee.id,
        );

        if (
          newEmployee.firstName !== oldEmployee.firstName ||
          newEmployee.lastName !== oldEmployee.lastName ||
          newEmployee.gender !== oldEmployee.gender ||
          newEmployee.departmentId !== oldEmployee.departmentId ||
          newEmployee.status !== oldEmployee.status ||
          newEmployee.phoneNumber !== oldEmployee.phoneNumber ||
          newEmployee.emailAddress !== oldEmployee.emailAddress
        ) {
          this.setState({ allEmployees: this.props.allEmployees });
          this.setState({ activeEmployees: this.props.activeEmployees });
          this.setState({
            terminatedEmployees: this.props.terminatedEmployees,
          });
        }
      });
    }
  }

  fetchEmployees = async () => {
    this.setState({ loading: true, errorMessage: null });

    // get auth token
    const { authToken } = this.props.currentUser;

    const response = await getEmployees(authToken);

    if (!response.success) {
      // if request failed but redux has a list of employees for us already,
      // take first 100 and show that
      const employees = this.props.allEmployees.slice(0, 100);

      if (employees.length > 0) {
        this.setState({ loading: false });
      } else {
        // show error message
        this.setState({
          loading: false,
          errorMessage: response.message,
        });
      }

      return;
    }

    // all good, update state with employees
    this.setState({ loading: false });

    // update redux
    this.props.setEmployees(response.employees);
  };

  togglePrintOutModal = () => {
    this.setState({
      openPrintOutModal: !this.state.openPrintOutModal,
    });
  };

  toggleImportModal = () => {
    this.setState({
      openImportDataModal: !this.state.openImportDataModal,
      openAddNewModal: this.state.openImportDataModal,
    });
  };

  onImportStudents = async (csvFile) => {
    this.setState({
      openImportDataModal: false,
      openLoaderModal: true,
      loaderModalErrorMessage: null,
      loaderModalDescription: 'Importing Employees...',
    });

    const formData = new FormData();
    formData.append('formFile', csvFile);

    // import students
    const response = await importEmployees(
      this.props.currentUser.authToken,
      formData,
    );

    if (!response.success) {
      this.setState({
        loaderModalErrorMessage: response.message,
        loaderModaltryAgainAction: () => {
          this.setState({ openLoaderModal: false, openImportDataModal: true });
        },
      });

      return;
    }

    this.setState({ openLoaderModal: false });

    this.fetchEmployees();
  };

  getDepartmentName = (employee) => {
    if (employee.departmentName) {
      return employee.departmentName;
    }
    if (employee.departmentId) {
      const department = this.state.departments.find(
        (dpt) => String(dpt.id) === String(employee.departmentId),
      );
      return department ? department?.description : '-';
    }
    return '-';
  };

  filter = () => {
    let employees =
      this.state.employeesToView === 'Active'
        ? [...this.state.activeEmployees]
        : [...this.state.terminatedEmployees];

    // if department is not empty, filter by department
    if (this.state.departmentId.length > 0) {
      employees = employees.filter(
        (item) => String(item.departmentId) === String(this.state.departmentId),
      );
    }

    // perform filter, if is male or female
    if (this.state.filter === 'Male' || this.state.filter === 'Female') {
      // filter based on gender
      employees = employees.filter((item) => item.gender === this.state.filter);
    }

    // perform query if any
    if (this.state.query.length > 0) {
      const query = this.state.query.toLowerCase();
      employees = employees.filter(
        (item) =>
          item.uniqueId.toLowerCase().includes(query) ||
          item.firstName.toLowerCase().includes(query) ||
          item.lastName.toLowerCase().includes(query),
      );
    }

    // sort employees by sortKey (case-insensitive, null-safe)
    employees = employees.sort((a, b) => {
      const aVal = (a[this.state.sortKey] || '').toString().toLowerCase();
      const bVal = (b[this.state.sortKey] || '').toString().toLowerCase();
      if (aVal < bVal) return -1;
      if (aVal > bVal) return 1;
      return 0;
    });

    return employees;
  };

  syncUrlState = (nextState = {}) => {
    const state = {
      ...this.state,
      ...nextState,
    };
    const search = getEmployeePageSearch(state);
    const nextSearch = search.length > 0 ? `?${search}` : '';

    if (nextSearch !== this.props.location.search) {
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: nextSearch,
      });
    }
  };

  exportEmployees = async () => {
    this.setState({
      openLoaderModal: true,
      loaderModalErrorMessage: null,
      loaderModalDescription: 'Exporting Employees...',
    });

    const response = await exportEmployees(this.state.employeesToView);

    if (response.success) {
      this.setState({
        openLoaderModal: false,
      });
      fileDownload(
        response.data.data,
        `employees-${this.state.employeesToView}-${new Date()}.xlsx`,
      );
    }

    this.setState({
      loaderModalErrorMessage: response.message,
      loaderModaltryAgainAction: this.exportEmployees,
    });
  };

  render() {
    const employees = this.filter();

    return (
      <div>
        <MainHeader />

        <MainLoaderModal
          openModal={this.state.openLoaderModal}
          loading={this.state.loaderModalLoadingStatus}
          description={this.state.loaderModalDescription}
          errorMessage={this.state.loaderModalErrorMessage}
          tryAgainAction={this.state.loaderModaltryAgainAction}
          cancelAction={() => this.setState({ openLoaderModal: false })}
        />

        <AddEmployeeModal
          openModal={this.state.openAddNewModal}
          employee={this.state.selectedEmployee}
          importAction={this.toggleImportModal}
          closeAction={() => this.setState({ openAddNewModal: false })}
        />

        <ImportDataModal
          openModal={this.state.openImportDataModal}
          heading="Import Employees"
          description="Add Employees in bulk through a CSV file. "
          importAction={(csvFile) => this.onImportStudents(csvFile)}
          cancelAction={this.toggleImportModal}
        />

        <ConfirmDeleteModal
          openModal={this.state.openConfirmDeleteModal}
          description={this.state.deleteDescription}
          deleteAction={this.state.deleteAction}
          deleteSuccessAction={this.state.deleteSucessAction}
          cancelAction={() => this.setState({ openConfirmDeleteModal: false })}
        />

        <PrintOutModal
          open={this.state.openPrintOutModal}
          department={
            this.state.departmentId.length > 0
              ? this.state.departments.find(
                  (dpt) => String(dpt.id) === String(this.state.departmentId),
                )?.description
              : 'ALL'
          }
          status={this.state.employeesToView}
          employees={this.filter()}
          school={this.props.currentUser.school}
          closeAction={this.togglePrintOutModal}
        />

        <ImportDataModal
          openModal={this.state.openImportModal}
          cancelAction={() => this.setState({ openImportModal: false })}
        />

        <div className="employee page-container">
          <div>
            <span className="h-18">Employees</span>

            <span className="right">
              <Mainmenu />
            </span>
          </div>

          <div className="mt-20">
            <div className="bx--row">
              <div className="bx--col-md-2">
                <div
                  className="card-add-employee pointer"
                  onClick={() => {
                    this.setState({ openAddNewModal: true });
                  }}
                >
                  <div className="plus-icon mt-10">
                    <Plus size="18" strokeWidth="3" />
                  </div>
                  <div className="text-label">ADD NEW EMPLOYEE</div>
                </div>
              </div>

              <div className="bx--col-md-2">
                <QuickActionCard
                  description={
                    <div className="employee-card-description">
                      <span>Active</span>
                      <span className="employee-count">
                        {this.state.activeEmployees.length}
                      </span>
                    </div>
                  }
                  hideAction2={true}
                  leftActionText="SHOW"
                  actionEvent1={() => {
                    this.setState({ employeesToView: 'Active' });
                  }}
                >
                  <Briefcase color="#fff" />
                </QuickActionCard>
              </div>
              <div className="bx--col-md-2">
                <QuickActionCard
                  description={
                    <div className="employee-card-description">
                      <span>Terminated</span>
                      <span className="employee-count">
                        {this.state.terminatedEmployees.length}
                      </span>
                    </div>
                  }
                  hideAction2={true}
                  leftActionText="SHOW"
                  actionEvent1={() => {
                    this.setState({ employeesToView: 'Terminated' });
                  }}
                >
                  <BriefcaseRed color="#fff" />
                </QuickActionCard>
              </div>
              <div className="bx--col-md-2">
                <QuickActionCard
                  description="Export Employees"
                  hideAction2={true}
                  leftActionText="EXPORT"
                  actionEvent1={this.exportEmployees}
                >
                  <Upload />
                </QuickActionCard>
              </div>
            </div>
          </div>

          <hr className="grey-hr mt-30" />

          <div className="mt-20">
            <span
              className="h-20"
              hidden={
                this.state.loading ||
                this.state.errorMessage != null ||
                this.state.allEmployees.length === 0
              }
            >
              {this.state.employeesToView}
            </span>

            <span
              className="right text-primary text-12 font-bold pointer"
              onClick={this.togglePrintOutModal}
            >
              <Printer size="12" strokeWidth="5px" /> &nbsp; PRINT
            </span>
          </div>

          <div
            className="mt-10"
            hidden={
              this.state.loading ||
              this.state.errorMessage != null ||
              this.state.allEmployees.length === 0
            }
          >
            <div className="card-row-3">
              <Select
                labelText="Filter by department"
                value={this.state.departmentId}
                onChange={(e) =>
                  this.setState({ departmentId: e.target.value })
                }
              >
                <SelectItem selected disabled text="Filter by department" />
                <SelectItem text="All" value="" />

                {this.props.departments.map((department) => (
                  <SelectItem
                    text={department.description}
                    value={department.id}
                  />
                ))}
              </Select>
              <div>
                <div
                  style={{ marginBottom: '12px', color: '#525252' }}
                  className="text-12"
                >
                  Search Employees
                </div>
                <Search
                  id="search"
                  name="search"
                  labelText="Search"
                  value={this.state.query}
                  onChange={(event) =>
                    this.setState({ query: event.target.value })
                  }
                  placeHolderText="Enter first name or last name to search"
                />
              </div>
              <Select
                labelText="Sort by"
                value={this.state.sortKey}
                onChange={(e) =>
                  this.setState(
                    {
                      sortKey: e.target.value,
                    },
                    this.syncUrlState,
                  )
                }
              >
                <SelectItem text="First Name" value="firstName" />
                <SelectItem text="Last Name" value="lastName" />
                <SelectItem text="Unique ID" value="uniqueId" />
              </Select>
            </div>
          </div>

          <div
            className="mt-10 employee-view-toggle"
            hidden={
              this.state.loading ||
              this.state.errorMessage != null ||
              this.state.allEmployees.length === 0
            }
          >
            <Toggle
              id="employee-view-toggle"
              aria-label="Toggle employee list view"
              labelA="Cards"
              labelB="Table"
              toggled={this.state.displayAsTable}
              onToggle={(toggled) =>
                this.setState({ displayAsTable: toggled }, this.syncUrlState)
              }
            />
          </div>

          <div className="mt-20" hidden={!this.state.loading}>
            <Loading
              small={true}
              withOverlay={false}
              description="Loading..."
            />
          </div>

          <div className="mt-30" hidden={this.state.errorMessage == null}>
            <span className="mt-10 text-danger">
              {this.state.errorMessage}.
            </span>
            &nbsp;
            <span
              className="text-primary pointer font-bold"
              onClick={() => this.fetchEmployees()}
            >
              TRY AGAIN
            </span>
          </div>

          <p
            className="text-14 mt-30 text-grey"
            hidden={
              this.state.allEmployees.length > 0 ||
              this.state.loading ||
              this.state.errorMessage !== null
            }
          >
            There are no employees
          </p>

          <RenderIf condition={!this.state.displayAsTable}>
            <div className="bx--row mt-30" hidden={this.state.loading}>
              {employees.map((employee) => (
                <div className="bx--col-lg-3 fade-in">
                  <EmployeeCard
                    editAction={() =>
                      this.setState({
                        openAddNewModal: true,
                        selectedEmployee: employee,
                      })
                    }
                    deleteAction={() =>
                      this.setState({
                        openConfirmDeleteModal: true,
                        deleteAction: async () => {
                          return await deleteEmployee(
                            this.props.currentUser.authToken,
                            {
                              ...employee,
                            },
                          );
                        },
                        deleteSucessAction: () => {
                          this.props.removeEmployee(employee.id);
                        },
                        deleteDescription: `Confirm deletion of Employee ${employee.firstName} ${employee.lastName} [${employee.uniqueId}]. This action cannot be reversed`,
                      })
                    }
                    employee={employee}
                  />
                </div>
              ))}
            </div>
          </RenderIf>

          <RenderIf condition={this.state.displayAsTable}>
            <div
              className="mt-30"
              hidden={
                this.state.loading || this.state.allEmployees.length === 0
              }
            >
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableHeader>ID</TableHeader>
                      <TableHeader>Name</TableHeader>
                      <TableHeader>Gender</TableHeader>
                      <TableHeader>Department</TableHeader>
                      <TableHeader>Actions</TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {employees.map((employee) => (
                      <TableRow key={employee.id}>
                        <TableCell>{employee.uniqueId}</TableCell>
                        <TableCell>
                          {employee.firstName} {employee.lastName}
                        </TableCell>
                        <TableCell>{employee.gender}</TableCell>
                        <TableCell>
                          {this.getDepartmentName(employee)}
                        </TableCell>
                        <TableCell>
                          {/* <Edit
                            size={16}
                            color="#164d9d"
                            style={{ marginRight: '8px', cursor: 'pointer' }}
                            onClick={() => {
                              this.setState({
                                openAddNewModal: true,
                                selectedEmployee: employee,
                              });
                            }}
                          />
                          <Trash2
                            size={16}
                            color="#da1818"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              this.setState({
                                openConfirmDeleteModal: true,
                                deleteAction: async () => {
                                  return await deleteEmployee(
                                    this.props.currentUser.authToken,
                                    {
                                      ...employee,
                                    },
                                  );
                                },
                                deleteSucessAction: () => {
                                  this.props.removeEmployee(employee.id);
                                },
                                deleteDescription: `Confirm deletion of Employee ${employee.firstName} ${employee.lastName} [${employee.uniqueId}]. This action cannot be reversed`,
                              });
                            }}
                          /> */}
                          <span
                            className="text-primary pointer font-bold"
                            onClick={() =>
                              this.props.history.push(
                                `/employees/${employee.id}`,
                              )
                            }
                          >
                            View
                          </span>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </RenderIf>

          <Footer fixed={false} showLinks={false} />
        </div>
      </div>
    );
  }
}

// this will provide us with the state values we need
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  departments: selectDepartments,
  allEmployees: selectAllEmployees,
  activeEmployees: selectActiveEmployees,
  terminatedEmployees: selectTerminatedEmployees,
});

// this allows us to map our redux actions to our component
const mapDispatchToProps = (dispatch) => ({
  setDepartments: (departments) => dispatch(setDepartments(departments)),
  setEmployees: (employees) => dispatch(setEmployees(employees)),
  removeEmployee: (employeeId) => dispatch(removeEmployee(employeeId)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmployeePage),
);
